import ApiKeysPanel from '@cartwhl/ui/feature/ApiKeysPanel';

export default function ProfileApiKeys() {
  return <ApiKeysPanel className="overview max-w-(--breakpoint-lg) mx-auto" />;
}
